import React from 'react';
import styles from './loader.module.css';
import Spinner from './Spinner';

/** Загрузка страницы или её части (ленивый чанк, перенаправление). */
const PageLoader: React.FC<{ caption?: string }> = ({ caption = 'Загрузка' }) => (
  <div className={styles.page}>
    <Spinner />
    <span className={styles.caption}>{caption}</span>
  </div>
);

export default PageLoader;
